import Dashboard from './views/Dashboard'
import Settings from './views/Settings'

const POSRoutes = [
    {
        path: '/pos',
        component: () => import(/* webpackChunkName: "pos-module" */ './POSModule.vue'),
        children: [
            { path: '', name: 'POS Dashboard', component: Dashboard },
            { path: 'settings', name: 'POS Settings', component: Settings },
            { path: 'settings/:setting', name: 'POS Setting', component: Settings, props: true },
            { path: 'register-logs', name: 'Register Logs', component: () => import(/* webpackChunkName: "register-logs" */ './views/RegisterLogs') },
            { path: 'register-codes', name: 'Register Codes', component: () => import(/* webpackChunkName: "register-codes" */ './views/RegisterCodes') },
            { path: 'reason-codes', name: 'Reason Codes', component: () => import(/* webpackChunkName: "reason-codes" */ './views/ReasonCodes') }
        ]
    }
]

export default POSRoutes
